/**
 * @desc 导出物流追踪tms单
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = any;
export function request(
  params: API.tms.transportMaster.exportTrackTmsReport.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/transportMaster/exportTrackTmsReport`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
